import React from 'react';
import { Skeleton } from '@cp/ds/src/components/skeleton';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { SearchIcon } from '@cp/ds/src/icons/search';
import { ClientType } from '@common/model/client/clientType';
import { Link, LinkProps } from '@cp/ds/src/components/link';
import { Tooltip } from '@cp/ds/src/components/tooltip';
import { Box } from '@cp/ds/src/components/box';
import { useClientProfile } from 'src/entities/client';
import { useHeaderFindBtnTooltipShown } from '../model/useHeaderFindBtnTooltipShown';

export const NavigateToCatalogLink: React.FC<LinkProps> = ({ sx, ...props }) => {
  const clientProfile = useClientProfile();

  const { isMessageVisible, isLoading, handleClick, setMessageVisible } = useHeaderFindBtnTooltipShown();

  if (!clientProfile) {
    return null;
  }

  const isSpecialist = clientProfile.type === ClientType.Specialist;

  return (
    <Stack direction="row" sx={sx}>
      {isLoading ? (
        <Skeleton width={120} />
      ) : (
        <Tooltip
          arrow
          colorSchema="dark"
          disableFocusListener
          disableHoverListener
          disableTouchListener
          onClose={() => setMessageVisible(false)}
          open={isMessageVisible}
          slotProps={{
            popper: {
              disablePortal: true,
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, 0],
                  },
                },
              ],
            },
          }}
          title={<Box sx={{ px: 1.75, py: 1 }}>{isSpecialist ? 'Найти работу' : 'Найти няню'}</Box>}
        >
          <Link onClick={handleClick} sx={{ display: 'flex' }} underline={false} {...props}>
            <SearchIcon />
            <Typography sx={{ ml: 0.75 }} variant="body bold">
              {isSpecialist ? 'Поиск работы' : 'Поиск бебиситтера'}
            </Typography>
          </Link>
        </Tooltip>
      )}
    </Stack>
  );
};

export default NavigateToCatalogLink;
